import api from 'shared/api';

export const setLicenseUserPassword = (userId, data) => {
  const url = `/api/v1/users/${userId}/set_password/`;
  return api.post(url, data);
};

// 16 characters so a generated password always rates as strong in the password form
export const generateLicenseUserPassword = () =>
  api.get('/api/v1/users/generate_password/?length=16');

export const sendLicenseUserPasswordSetupLink = (userId) =>
  api.post(`/api/v1/users/${userId}/send_password_setup_link/`);
